// API Configuration
const config = {
  // API URL - uses environment variable in production, localhost in development
  API_BASE_URL: process.env.NODE_ENV === 'production'
    ? process.env.VUE_APP_API_URL || 'https://multicare-luckydraw.onrender.com/api'
    : 'http://localhost:5001/api',
};

export default config; 